import { useEffect, useState } from 'react';
import { CostingService } from '../../services/costing.service';
import { AuthService } from '../../services/auth.service';
import { usePermission } from '../../hooks/usePermission';
import { PERMISSIONS } from '../../constants/permissions';
import { useDashboardAccess } from '../dashboard/useDashboardAccess';

/**
 * True when journal lines of this institution can be tagged with a buyer order: Merchandising is enabled, order
 * costing is switched on and the caller can view buyer orders (B4-0, 0-5). Any failure of the check hides the column.
 */
export function useOrderTagging(): boolean {
    const { enabledModules } = useDashboardAccess();
    const merchandising = enabledModules.has('merchandising');
    const canViewOrders = usePermission(PERMISSIONS.BUYER_ORDER_VIEW);
    const [on, setOn] = useState(false);
    const institutionId = AuthService.getSelectedInstitution();

    useEffect(() => {
        let live = true;
        if (!institutionId || !merchandising || !canViewOrders) {
            setOn(false);
            return () => { live = false; };
        }
        CostingService.isEnabled(institutionId)
            .then(v => { if (live) setOn(v === true); })
            .catch(() => { if (live) setOn(false); });
        return () => { live = false; };
    }, [institutionId, merchandising, canViewOrders]);

    return on;
}
